interface FilterGroupProps {
  title: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
}

export default function FilterGroup({ title, options, value, onChange }: FilterGroupProps) {
  return (
    <div className="border-b border-background-200 pb-5 last:border-b-0 last:pb-0">
      <h4 className="mb-3 font-heading text-sm font-semibold text-foreground-900">{title}</h4>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => (
          <button
            key={option}
            type="button"
            onClick={() => onChange(option)}
            className={`cursor-pointer whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
              value === option
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-600'
            }`}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
}